import { QuoteLocation } from "./quote-location.model";
import { LocationMapper } from "app/location/location.mapper";
import { LocationGroupMapper } from "app/location-group/location-group.mapper";

export class QuoteLocationMapper {
  public static map(data: any): QuoteLocation {
    return new QuoteLocation(
      data.id,
      data.location ? LocationMapper.map(data.location) : null,
      data.inlandHaulage,
      data.postalCode,
      data.latitude,
      data.longitude,
      data.country,
      data.locationGroup ? LocationGroupMapper.map(data.locationGroup) : null,
    );
  }
}
